/*
 * @Descripttion: 直播回看
 * @Author: gouyang
 * @Date: 2021-01-21 14:54:13
 * @LastEditors: gouyang
 * @LastEditTime: 2021-03-26 17:23:53
 */
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { Modal } from 'antd';
import { Env, RecordPlayingTime } from 'record-playing-time';
import livingGif from '../../../../assets/living.gif';
import { PlaybackInfo, N, ListsInfo, SelectedInfo } from '../../interface';
import { getSearchParams, getUserId } from '../../../../util';
import AxiosWrap from '../../../../lib/request';
import './index.less';
import { VideoMarkerPlayer } from 'video-marker-player';
import { PlayTime } from '../../../../util/playTime';

export function getEnv(): Env {
  const env = (window as any).__UNION_CENTER_ENV__;
  switch (env) {
    case 'DEV':
      return 'dev';
    case 'TEST':
      return 'test';
    case 'STAGE':
      return 'pro';
    case 'PROD':
      return 'pro';
    default:
      return 'dev';
  }
}

const recordPlayingTime: RecordPlayingTime = new RecordPlayingTime(getEnv());
interface P {
  playbackInfo: PlaybackInfo;
}

function LivePlayBack(props: P) {
  const { playbackInfo } = props;
  const PlayTimeFn = PlayTime();
  const isTurnTo = useRef(false);
  let xgPlayer: any = null;
  const ids = useRef<any>({
    fileId: '',
    resourceId: getSearchParams().liveId,
    lessonId: getSearchParams().id,
    courseId: getSearchParams().courseId,
    source: 0,
    userId: getUserId(),
  });

  const searchParams = useRef<N>(getSearchParams());
  const [listsInfo, setPlaybackLists] = useState<ListsInfo>({
    playBack: false,
    playBackLists: [],
    provider: -1,
  });
  const [selectedInfo, setSelectedInfo] = useState<SelectedInfo>({
    i: 0,
    url: '',
  });
  // const [fileType, setFileType] = useState<string>('');

  const playBackModal = useCallback(() => {
    const { ignoreClose } = searchParams.current;
    Modal.info({
      title: '直播生成中，请耐心等待',
      onOk() {
        if (!ignoreClose) {
          (window as any).history.back();
        }
      },
    });
  }, []);

  const createLocalPlayBackUrl = useCallback(async (fileId: string, fileName: string) => {
    const { data, status } = await AxiosWrap({
      url: `/files/${fileId}/preview?type=${0}&fileName=${encodeURIComponent(fileName)}`,
      params: {
        resourceId: getSearchParams().liveId,
        lessonId: getSearchParams().id,
        courseId: getSearchParams().courseId,
      },
    });
    if (status === 200 && data) {
      // setFileType(data.extension);
      return data.cdnUrl;
    }
    return '';
  }, []);

  const ceatePlayBackUrl = useCallback(
    (info: any): Promise<string> => {
      const { name, fileId } = info;
      ids.current.fileId = fileId;
      return Promise.resolve(createLocalPlayBackUrl(fileId, name));
    },
    [createLocalPlayBackUrl],
  );

  const enterPlayBack = useCallback(
    async (info: any[], provider: number) => {

      if (!info || (info && info.length < 1)) {
        playBackModal();
        return;
      }
      setPlaybackLists({
        playBack: true,
        playBackLists: info,
        provider,
      });
      setSelectedInfo({
        i: 0,
        url: await ceatePlayBackUrl(info[0]),
      });
    },
    [playBackModal, ceatePlayBackUrl],
  );

  // 创建回看
  const cratePlayBack = useCallback(
    (playBack: PlaybackInfo) => {
      const { provider, easteduPlaybacks } = playBack;
      enterPlayBack(easteduPlaybacks, provider);
    },
    [enterPlayBack],
  );

  const onPlayBackChange = useCallback(
    async (review: any, i: number) => {
      if (i !== selectedInfo.i) {
        setSelectedInfo({
          i,
          url: await ceatePlayBackUrl(review),
        });
      }
    },
    [selectedInfo, ceatePlayBackUrl],
  );


  useEffect(() => {
    const { provider } = playbackInfo;
    if (provider !== -1) {
      cratePlayBack(playbackInfo);
    }
  }, [playbackInfo, cratePlayBack]);

  useEffect(() => {
    return () => {
      recordPlayingTime.clearStatus();
    };
  }, []);

  const onSiderTrack = (data: any) => {
    switch (data.trackType) {
      case 'PROGRESS_CLICK':
      case 'DRAG_END':
      case 'MARKER_CLICK':
        if (xgPlayer?.currentTime < xgPlayer?.duration) {
          isTurnTo.current = true;
        }
        break;
      default:
        break;
    }
  };

  const playDom = () => {
    if (!selectedInfo.url) {
      return null;
    }
    // 点播课时且是mp4
    return (
      <VideoMarkerPlayer
        defaultSilderOpen
        theme="#2683f5"
        videoUrl={selectedInfo.url}
        onVideoTrack={(data) => onSiderTrack(data)}
        playerOptions={
          {
            events: {
              play: (player: any) => {
                xgPlayer = player;
                PlayTimeFn.startPlayTime({ ...ids.current });
              },
              pause: () => {
                PlayTimeFn.stopPlayTime();
              },
              ended: (player: any) => {
                player.exitFullscreen();
              },
              timeupdate: (player: any) => {
                PlayTimeFn.getStartAndEnd(player.currentTime, player.duration, isTurnTo.current);
                isTurnTo.current = false;
              },
              ratechange: (player: any) => {
                PlayTimeFn.changePlayRate(player.playbackRate);
              },
            },
            xgplayerOptions: {
              autoplayMuted: false,
              autoplay: true,
            },
          } as any
        }
      />
    );
  };

  return (
    <>
      {listsInfo.playBack && (
        <div className="play-back">
          {playDom()}
          {listsInfo.playBackLists.length > 1 && (
            <div className="review-bar">
              {listsInfo.playBackLists.map((review: any, i: number) => (
                <div
                  className={`review-item ${selectedInfo.i === i && 'item-selected'}`}
                  onClick={() => onPlayBackChange(review, i)}
                  key={i}
                >
                  {selectedInfo.i === i && <img src={livingGif} alt="" />}
                  {review.name || review.subject}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default memo(LivePlayBack);
